import { render, staticRenderFns } from "./ReportsMenu.vue?vue&type=template&id=ff884196&scoped=true&"
import script from "./ReportsMenu.vue?vue&type=script&lang=js&"
export * from "./ReportsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReportsMenu.vue?vue&type=style&index=0&id=ff884196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff884196",
  null
  
)

export default component.exports